import React, { useState, useRef } from 'react';
import ReactPlayer from 'react-player';
import { FiPlay, FiPause, FiVolume2, FiVolumeX } from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

export default function StickyAudioPlayer() {
  const [playing, setPlaying] = useState(false);
  const [volume, setVolume] = useState(0.8);
  const [muted, setMuted] = useState(false);
  const [played, setPlayed] = useState(0);
  const [duration, setDuration] = useState(0);
  const playerRef = useRef(null);

  const togglePlay = () => setPlaying(!playing);
  const toggleMute = () => setMuted(!muted);

  const handleVolumeChange = (e) => {
    setVolume(parseFloat(e.target.value));
  };

  const handleProgress = (state) => {
    setPlayed(state.played);
  };

  const handleDuration = (duration) => {
    setDuration(duration);
  };

  const handleSeekChange = (e) => {
    setPlayed(parseFloat(e.target.value));
  };

  const handleSeekMouseUp = (e) => {
    playerRef.current.seekTo(parseFloat(e.target.value));
  };

  const formatTime = (seconds) => {
    const date = new Date(seconds * 1000);
    const hh = date.getUTCHours();
    const mm = date.getUTCMinutes();
    const ss = date.getUTCSeconds().toString().padStart(2, '0');
    if (hh) {
      return `${hh}:${mm.toString().padStart(2, '0')}:${ss}`;
    }
    return `${mm}:${ss}`;
  };

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 bg-grunge-black border-t-2 border-sun-yellow/50 shadow-[0_-5px_15px_rgba(0,0,0,0.5)] backdrop-blur-md px-4 py-2 flex flex-col md:flex-row items-center justify-between">

      {/* Hidden ReactPlayer for audio processing */}
      <ReactPlayer
        ref={playerRef}
        url="https://soundcloud.com/andy-lodic/meredith-brooks-bitch-live-lilith-fair-97"
        playing={playing}
        volume={volume}
        muted={muted}
        onProgress={handleProgress}
        onDuration={handleDuration}
        width="0"
        height="0"
        style={{ display: 'none' }}
        config={{
          soundcloud: {
            options: { auto_play: false }
          }
        }}
      />

      {/* Track Info */}
      <div className="flex items-center w-full md:w-1/3 mb-2 md:mb-0">
        <div className="w-10 h-10 bg-sun-yellow rounded flex items-center justify-center mr-3 flex-shrink-0">
          <span className="text-black font-display text-xl leading-none pt-1">MB</span>
        </div>
        <div className="overflow-hidden">
          <h4 className="text-white text-sm font-bold truncate">"Bitch" live at Lilith Fair '97</h4>
          <p className="text-gray-400 text-xs truncate">Meredith Brooks</p>
        </div>
      </div>

      {/* Controls & Progress */}
      <div className="flex flex-col items-center w-full md:w-1/3 mb-2 md:mb-0">
        <div className="flex items-center justify-center space-x-4 mb-1">
          <button
            onClick={togglePlay}
            className="w-10 h-10 rounded-full bg-sun-yellow flex items-center justify-center hover:bg-white transition-colors hover:scale-105 active:scale-95"
            aria-label={playing ? 'Pause' : 'Play'}
          >
            <SafeIcon icon={playing ? FiPause : FiPlay} className="w-5 h-5 text-black ml-1" />
          </button>
        </div>

        <div className="flex items-center w-full max-w-md space-x-3 text-xs text-gray-400">
          <span>{formatTime(duration * played)}</span>
          <input
            type="range"
            min={0}
            max={1}
            step="any"
            value={played}
            onMouseDown={() => setPlaying(false)}
            onChange={handleSeekChange}
            onMouseUp={(e) => {
               handleSeekMouseUp(e);
               setPlaying(true);
            }}
            className="w-full h-1 bg-gray-600 rounded-lg appearance-none cursor-pointer accent-sun-yellow"
          />
          <span>{formatTime(duration)}</span>
        </div>
      </div>

      {/* Volume */}
      <div className="flex items-center justify-end w-full md:w-1/3 space-x-2">
        <button onClick={toggleMute} className="text-gray-400 hover:text-sun-yellow transition-colors">
          <SafeIcon icon={muted || volume === 0 ? FiVolumeX : FiVolume2} className="w-5 h-5" />
        </button>
        <input
          type="range"
          min={0}
          max={1}
          step="any"
          value={muted ? 0 : volume}
          onChange={handleVolumeChange}
          className="w-24 h-1 bg-gray-600 rounded-lg appearance-none cursor-pointer accent-sun-yellow"
        />
      </div>

    </div>
  );
}
